let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("8DPN8")]).then(() => parcelRequire('9FliJ'));